<template>
  <div class="bgs">
      <Header></Header>
        <div class="IdAuthentication_box">
                <div class="IdAuthentication_box_title">请选择您的身份</div>
                <div class="IdAuthentication_box_list">
                    <div class="IdAuthentication_box_list_left">
                        <img src="../assets/img/zhuanjia_icon.png" alt="">
                        <div class="titles1">专家认证</div>
                        <div class="titles2">用于学者、研究员或分析师等 专家人士的认证</div>
                        <div class="titles3" @click="Go_ExpertCertification">申请认证</div>
                    </div>
                    <div class="IdAuthentication_box_list_right">
                          <img src="../assets/img/jigou_icon.png" alt="">
                        <div class="titles1">机构认证</div>
                        <div class="titles2">用于高校、科研院所、研究院等 专业机构组织的认证</div>
                        <div class="titles3" @click="Go_AgencyCertification">申请认证</div>
                    </div>
                </div>
        </div>
        <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue"
import Footer from '../components/Footer.vue'
export default {    
    components:{
        Header,
        Footer
    },
    methods:{
        Go_ExpertCertification(){
            this.$router.push({ path: '/ExpertCertification' });
        },
        Go_AgencyCertification(){
            this.$router.push({ path: '/AgencyCertification' });
        }
    }
}
</script>

<style scoped>
.bgs{
    background:#f5f7f9;
}
.IdAuthentication_box{
    width:1200px;
    height:700px;
    background:#fff;
    margin:20px auto 175px;
}
.IdAuthentication_box_title{
    height:60px;
    text-align:center;
    line-height:60px;
    font-size: 22px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
border-bottom:1px solid #E8E8E8;
}
.IdAuthentication_box_list{
    display:flex;
    justify-content: space-around;
    margin-top:80px;
}
.IdAuthentication_box_list_left{
    width: 324px;
height: 442px;
background: #FFF2E5;
border-radius: 6px;
}
.IdAuthentication_box_list_right{
width: 324px;
height: 442px;
background: #E5F2FF;
border-radius: 6px;
}
.IdAuthentication_box_list_left{
    display:flex;
    align-items: center;
    flex-direction: column;
    padding:0 37px;
    box-sizing: border-box;
    text-align:center;
}
.IdAuthentication_box_list_left img{
    width:66px;
    height:60px;
    margin-top:68px;
    margin-bottom:65px;
}
.IdAuthentication_box_list_left .titles1{
font-size: 24px;
font-family: PingFang SC;
font-weight: bold;
color: #E98A55;
margin-bottom:41px;
}
.IdAuthentication_box_list_left .titles2{
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
}
.IdAuthentication_box_list_left .titles2{
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
margin-bottom:48px;
}
.IdAuthentication_box_list_left .titles3{
    width: 160px;
height: 48px;
background: linear-gradient(0deg, #E98A55, #F4C580);
border-radius: 4px;
text-align:center;
line-height:48px;
cursor: pointer;
font-size: 20px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
}

.IdAuthentication_box_list_right{
    display:flex;
    align-items: center;
    flex-direction: column;
    padding:0 37px;
    box-sizing: border-box;
    text-align:center;
}
.IdAuthentication_box_list_right img{
    width:66px;
    height:60px;
    margin-top:68px;
    margin-bottom:65px;
}
.IdAuthentication_box_list_right .titles1{
font-size: 24px;
font-family: PingFang SC;
font-weight: bold;
color: #5179DD;
margin-bottom:41px;
}
.IdAuthentication_box_list_right .titles2{
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
}
.IdAuthentication_box_list_right .titles2{
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
margin-bottom:48px;
}
.IdAuthentication_box_list_right .titles3{
    width: 160px;
height: 48px;
background: linear-gradient(0deg, #5179DD, #7AB6EE);
border-radius: 4px;
text-align:center;
line-height:48px;
cursor: pointer;
font-size: 20px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
}

</style>